import type { PartnerLegalAgreement, PartnerLegalAgreementStateChange } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import axios from 'axios';

export const legalAgreements = {
  /**
   * Get current acceptance state for a legal agreement type
   */
  get: {
    queryKey: 'partner-management-service/legalAgreements',
    configurationType: 'no-cache' as const,
    fn: async (
      partnerId: string,
      type: PartnerLegalAgreementStateChange['legalAgreementType'],
    ): Promise<PartnerLegalAgreement | null> => {
      try {
        const { data } = await GatewayAxiosClient.get<PartnerLegalAgreement>(
          `/partner-management-proxy/api/v1/partners/${partnerId}/legalAgreements`,
          {
            params: { type },
          },
        );
        return data;
      } catch (error: unknown) {
        // 404 means no agreement exists yet - return null
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
  },

  /**
   * Change acceptance state (creates new snapshot)
   */
  changeState: async ({ partnerId, payload }: { partnerId: string; payload: PartnerLegalAgreementStateChange }) => {
    const { data } = await GatewayAxiosClient.put<PartnerLegalAgreement>(
      `/partner-management-proxy/api/v1/partners/${partnerId}/legalAgreements`,
      payload,
    );
    return {
      data,
      invalidateQueryKeys: [['partner-management-service/legalAgreements', partnerId, payload.legalAgreementType]],
    };
  },
};
